import { useParams } from "react-router-dom"

/**
 * @deprecated You probably want to use useClubId
 */
export const useOrgId = (): string => {
  const { orgId } = useParams<{ orgId: string }>()

  return orgId ?? "-1"
}
